// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__37YWU","content":"styles_content__3B1ne","row":"styles_row__2n7rQ","footer":"styles_footer__3MdbX","phraseLength":"styles_phraseLength__1mLYe"};